const BASE = "/inventory";

const GET_INVENTORIES = `${BASE}/get-inventories`;
const CREATE_INVENTORY = `${BASE}/create-inventory`;
const UPDATE_INVENTORY = `${BASE}/update-inventory/{INVENTORY_ID}`;
const GET_DETAIL_INVENTORY = `${BASE}/get-detail-inventory/{INVENTORY_ID}`;

/**INVENTORY REVISION */
const GET_LIST_INVENTORY_REVISION = `${BASE}/get-list-inventory-revision/{INVENTORY_ID}`;
const GET_DIFF_INVENTORY_REVISION = `${BASE}/get-diff-revision/{REVISION_ID}`;

export const INVENTORY_ROUTER = {
  GET_INVENTORIES,
  GET_DETAIL_INVENTORY,
  CREATE_INVENTORY,
  UPDATE_INVENTORY,

  /**INVENTORY REVISION */
  GET_LIST_INVENTORY_REVISION,
  GET_DIFF_INVENTORY_REVISION,
};
